module.exports = __webpack_public_path__ + "img/yaopincaigouruku.6451dcd0.png";